import {Button, Card, Form, Spin} from 'antd';
import React from "react";
import {getFormFieldByType} from "../../util/methods";
import DocumentList from "../../components/DocumentList";
import SubList from "../../components/SubList";

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      documentData: [],
    }
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  getDocumentData = (data) => {
    this.setState({documentData: data});
  };

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const {documentData} = this.state;

      const data = Object.assign({}, values);
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {data, loading, filters, title, resource, subDocumentFilters, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {

              if (filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>
              } else {
                if (item !== 'refurbishmentTransactionNo') {
                  return getFormFieldByType(filters, item, getFieldDecorator, data, {resource, title, setFieldsValue})
                }
              }
            })}

            {filters && filters.documents &&
            <DocumentList history={this.props.history} match={this.props.match} key={filters.documents}
                          item={filters.documents} form={form} data={data.documents}
                          getDocumentData={this.getDocumentData}/>}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
